import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import PopupWrapper from "../Common/PopupWrapper";
import i18next from "i18next";
import RadioGroupJson from "./../Common/RadioGroupJson";
import CheckBoxJson from "./../Common/CheckBoxJson";
import parse from "html-react-parser";
import {GlobalDebugMode} from "@mnjsplatform/data";
import ReactToPrint from "react-to-print";

const customFieldExMap = {
    RadioGroupJson: (props) => <RadioGroupJson {...props} />,
    CheckBoxJson: (props) => <CheckBoxJson {...props} />
};

class TemplateForm extends Component {
    constructor(props, context) {
        super(props, context);
        this.refForPrint = React.createRef();
        this.state = {
            templateText: null,
            data: null,
            isDataReady: false
        }
    }

    componentDidMount() {
        this.initialize();
    }

    initialize = async () => {
        try {
            this.setState({isDataReady: false});
            //console.log(`this.props.rowKey=${JSON.stringify(this.props.rowKey)}`);
            await this.props.dispatch(this.props.dataItem_Template.reset());
            await this.props.dispatch(this.props.dataItem_Template.initialize(this.props.rowKey, {
                newItem: true,
                withParams: false
            }));

            let templateText = null;
            if (!this.props.dataItem_Template.isError) {
                const templateRow = this.props.dataItem_Template.getRow(0);
                templateText = templateRow.WebTemplate;
                if (templateText && templateText.length > 0) {
                    this.setState({
                        templateText: templateText
                    });
                    await this.props.dispatch(this.props.dataItem_TemplateData.reset());
                    await this.props.dispatch(this.props.dataItem_TemplateData.initialize(this.props.rowKey, {
                        newItem: true,
                        withParams: false
                    }));
                    await this.prepareData();
                }
            }
            //console.log(`this.state.templateText=${JSON.stringify(this.state.templateText)}`);
        } finally {
            this.setState({isDataReady: true});
        }
    }
    prepareData = async () => {
        const rows = this.props.dataItem_TemplateData.rawData.DataTable;
        const data = await Promise.all(rows.map(async (row) => {
            if (row.IsTable === 1) {
                const key = Object.assign({}, this.props.rowKey, {DataName: row.DataName});
                await this.props.dispatch(this.props.dataItem_Table.execute(key));
                const value = this.getTable(this.props.dataItem_Table.rawData.DataTable);
                return {DataName: row.DataName, DataValue: value, IsTable: row.IsTable};
            } else {
                return row;
            }
        }));
        this.setState({data});
    }
    getTable = (rows) => {
        if (!rows || rows.length === 0)
            return null;
        return <div className="container">
            <div className="row font-weight-bold">
                {Object.keys(rows[0]).filter(h => h !== '#IDACKey#').map(header => <div
                    className="col border">{header}</div>)}
            </div>
            {
                rows.map(row => {
                    return <div className="row">
                        {
                            Object.entries(row).filter(([key, value]) => key !== '#IDACKey#').map(([key, value]) => {
                                return <div className="col border">{value}</div>
                            })
                        }
                    </div>
                })
            }
        </div>;
    }
    hasData = () => {
        return this.state.templateText && this.state.templateText.length > 0 && this.state.data && this.state.data.length > 0
    }
    renderButtons = () => {
        return (
            <div className="modal-footer text-right">
                {this.hasData() &&
                    <ReactToPrint
                        trigger={() => <button type="button"
                                               className="btn btn-regular -goahead mb-1">{i18next.t("Print")}</button>}
                        content={() => this.refForPrint.current}
                        //                    onBeforeGetContent={this.prepareForPrint}
                    />
                }
                <button type="button" className="btn btn-regular -default" data-dismiss="modal"
                        onClick={() => this.props.onClose({refresh: false})}>{this.state.buttonTextCancel || i18next.t("Cancel_Noun")}</button>
            </div>
        );
    }

    render() {
        if (!this.state.isDataReady)
            return null;

        return (
            <>
                <PopupWrapper popupVisible={true} title={this.props.title}
                              staticTitle={i18next.t("Request")}
                              onClose={this.props.onClose} renderButtons={this.renderButtons} instructionId="10">
                    <div ref={this.refForPrint}>
                        {this.renderForm()}
                    </div>
                </PopupWrapper>
            </>
        );
    }

    renderForm = () => {
        if (!this.state.templateText || this.state.templateText.length === 0)
            return <span className='text-danger'>{i18next.t('NoDocumentTemplate')}</span>;

        if (!this.state.data || this.state.data.length === 0) {
            return <span className='text-danger'>{i18next.t('NoData')}</span>;
        }
        return <>
            {
                parse(this.state.templateText, {
                    replace: domNode => {
                        if (domNode.name === "label" && domNode.attribs && domNode.attribs.name) {
                            return this.renderLabel(this.state.data, domNode.attribs.name);
                        }
                        return domNode;
                    }
                })}
            {GlobalDebugMode &&
                <div className="border p-1">{this.state.data && this.state.data.map(row =>
                    <div>{row.DataName}: {row.DataValue}</div>)}</div>}
        </>;
    }
    renderLabel = (rows, fieldName) => {
        if (!fieldName || !rows)
            return null;
        const row = rows.find(row => row.DataName === fieldName);
        return <>{row?.DataValue}</>
    }
}

TemplateForm.propTypes = {
    dispatch: PropTypes.func.isRequired,
    dataItem_Template: PropTypes.object,
    dataItem_TemplateData: PropTypes.object,
    dataItem_Table: PropTypes.object,
    onClose: PropTypes.func,
    rowKey: PropTypes.object.isRequired,
    readOnly: PropTypes.bool,
    title: PropTypes.string
};

TemplateForm.defaultProps = {
    onClose: () => {
    }
};

function mapStateToProps(state, ownProps) {
    return {
        dataItem_Template: state.dailyChartState.AppPers_GetWebTempl,
        dataItem_TemplateData: state.dailyChartState.AppPers_GetWebData,
        dataItem_Table: state.dailyChartState.AppPers_GetWebDataList
    }
}

export default connect(mapStateToProps)(TemplateForm);